import PropTypes from "prop-types"
import React from "react"
import { useMutation, useQueryClient } from "react-query"
import { useMarina } from "src/contexts/MarinaContext"
import JobLineItemForm from "src/main/Service/Manage/shared/JobLineItemForm"

import Modal from "src/components/Modal"

import { createJobLineItem } from "src/api/Service/JobLineItems"

import { useToast } from "src/hooks/use_toast"

const AddJobLineItemModal = ({
  isOpen,
  onClose,
  jobId,
  availability,
  modalTitle,
  boatLengthFeet,
}) => {
  const { marinaSlug } = useMarina()
  const showToast = useToast()
  const queryClient = useQueryClient()

  const { mutate: submitLineItem } = useMutation(
    (vars) => createJobLineItem(marinaSlug, jobId, vars),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["jobLineItems", marinaSlug, jobId])
        onClose()
        showToast("Line item added.", { type: "success" })
      },
      onError: (error) => {
        showToast(error.message || "Failed to add line item.", {
          type: "error",
        })
      },
    }
  )

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="default">
      <Modal.Header title={modalTitle} />
      <Modal.Body>
        <JobLineItemForm
          availability={availability}
          boatLengthFeet={boatLengthFeet}
          onSubmit={({ productId, pricePerUnit, quantity, notes }) =>
            submitLineItem({ productId, pricePerUnit, quantity, notes })
          }
          onCancel={onClose}
          submitLabel={modalTitle}
        />
      </Modal.Body>
    </Modal>
  )
}

AddJobLineItemModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  availability: PropTypes.oneOf(["service_labor", "service_parts"]).isRequired,
  modalTitle: PropTypes.string.isRequired,
  boatLengthFeet: PropTypes.number,
}

export default AddJobLineItemModal
